var exports = {
  "kL": "GuildWebhooksTab.module__container___dllpaG",
  "wx": "GuildWebhooksTab.module__header___dllpaG",
  "DD": "GuildWebhooksTab.module__title___dllpaG",
  "VA": "GuildWebhooksTab.module__subtitle___dllpaG",
  "lm": "GuildWebhooksTab.module__notice___dllpaG",
  "et": "GuildWebhooksTab.module__infoBox___dllpaG",
  "dc": "GuildWebhooksTab.module__spinnerContainer___dllpaG",
  "g": "GuildWebhooksTab.module__webhookList___dllpaG",
  "wp": "GuildWebhooksTab.module__followedSection___dllpaG",
  "Gf": "GuildWebhooksTab.module__sectionTitle___dllpaG",
  "yV": "GuildWebhooksTab.module__sectionDescription___dllpaG",
  "kT": "GuildWebhooksTab.module__followedGroup___dllpaG",
  "QO": "GuildWebhooksTab.module__followedGroupTitle___dllpaG",
};

module.exports = exports;
